import { Tooltip, StackView } from "@planningcenter/tapestry-react"
import { bool, node, string, func } from "prop-types"
import { Checkbox } from "components/ui"

const HIDDEN = "hidden"
const OPTIONAL = "optional"
const REQUIRED = "required"

const PersonInfoCheckboxRow = ({
  attribute,
  text,
  value,
  forceRequired = false,
  emergencyHelperShelfMessage = "",
  onSelect
}) => {
  const handleInfoCheckboxClick = ({ target: { checked } }) => {
    onSelect(checked ? OPTIONAL : HIDDEN)
  }

  const handleRequiredCheckboxClick = () => {
    onSelect(value === REQUIRED ? OPTIONAL : REQUIRED)
  }

  return (
    <Tooltip
      placement="top"
      title={forceRequired ? `${text} is required when a restriction is in place.` : ""}
    >
      <StackView key={attribute} axis="horizontal" distribution="space-between">
        <Checkbox
          name={`personalInfoCheckbox_${attribute}`}
          htmlFor={`personalInfoCheckbox_${attribute}`}
          text={attribute === "medical" ? "Medical notes" : text}
          checked={value !== HIDDEN}
          onSelect={handleInfoCheckboxClick}
          disabled={forceRequired}
          wrapperClasses="mb-0"
          helperMessage={attribute === "emergency_contact" ? emergencyHelperShelfMessage : null}
          helperMessageStyle={
            attribute === "emergency_contact" ? { width: "calc(100% + 16px)" } : null
          }
        />
        {attribute === "medical" ? (
          <span className="c-neutral-500" css={{ fontSize: "14px" }}>
            Optional only
          </span>
        ) : (
          <Checkbox
            name={`personalInfoRequiredCheckbox_${attribute}`}
            htmlFor={`personalInfoRequiredCheckbox_${attribute}`}
            checked={value === REQUIRED}
            onSelect={handleRequiredCheckboxClick}
            disabled={forceRequired}
            wrapperClasses="checkbox-top-adjusted"
          />
        )}
      </StackView>
    </Tooltip>
  )
}

PersonInfoCheckboxRow.propTypes = {
  attribute: string.isRequired,
  text: node.isRequired,
  value: string.isRequired,
  forceRequired: bool,
  emergencyHelperShelfMessage: string.isRequired,
  onSelect: func.isRequired
}

export default PersonInfoCheckboxRow
